<template>

  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="90%" append-to-body @closed="onClosed">

    <template slot="title">

      <div class="doc-dialog-header">

        <span class="doc-dialog-title">{{ dialogTitle }}</span>

        <div v-if="showViewToolbar" class="doc-dialog-actions">

          <el-button-group>

            <workflow-doc-buttons biz-type="counting" :biz-id="form.countingId" perm="inventory:counting" :approve-status="String(form.approveStatus || '0')" @approve="approve(true)" @unapprove="approve(false)" />

            <el-button v-if="isAuth('inventory:counting:update')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="readonly = false">修改</el-button>

            <el-button v-if="isAuth('inventory:counting:delete')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="remove">删除</el-button>

          </el-button-group>

        </div>

      </div>

    </template>

    <el-form :model="form" label-width="90px">

      <el-row>

        <el-col :span="6"><el-form-item label="单号" required><el-input v-model="form.countingCode" :disabled="formDisabled || codeReadonly || !!form.countingId" :placeholder="codeReadonly ? '保存时自动编号' : ''" /></el-form-item></el-col>

        <el-col :span="6"><el-form-item label="日期" required><el-date-picker v-model="form.countingDate" type="date" value-format="yyyy-MM-dd" style="width:100%" :disabled="formDisabled" /></el-form-item></el-col>

        <el-col :span="6"><el-form-item label="备注"><el-input v-model="form.remark" :disabled="formDisabled" /></el-form-item></el-col>

      </el-row>

      <el-row v-if="form.countingId">

        <el-col :span="6">

          <el-form-item label="审核状态">

            <el-tag :type="statusTagType" size="small">{{ statusText }}</el-tag>

          </el-form-item>

        </el-col>

      </el-row>

    </el-form>

    <div v-if="inventoryBarcodeEnabled && !formDisabled" class="line-tools">

      <el-input v-model="barcodeScanCode" size="small" placeholder="扫描条码解析物料（非序列号）" clearable style="width:320px;" @keyup.enter.native="onBarcodeScanForLine" />

      <el-button type="primary" size="small" style="margin-left:8px;" @click="onBarcodeScanForLine">扫码加行</el-button>

    </div>

    <div class="line-tools">

      <el-button v-if="!formDisabled" type="primary" size="small" @click="addLine">新增行</el-button>

      <el-button v-if="!formDisabled" type="primary" size="small" style="margin-left:8px;" @click="materialVisible = true">选择物料</el-button>

      <el-button v-if="!formDisabled" type="primary" size="small" style="margin-left:8px;" @click="openWarehouseStock">按仓库带出</el-button>

      <el-upload v-if="!formDisabled" :show-file-list="false" action="" :http-request="doImport" accept=".xlsx" style="display:inline-block;margin-left:8px;">

        <el-button type="primary" size="small">导入(产品编码)</el-button>

      </el-upload>

      <el-button v-if="!formDisabled" size="small" style="margin-left:8px;" @click="downloadTemplate">下载导入模板</el-button>

    </div>

    <el-table border :data="form.lines" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">

      <el-table-column type="index" label="序号" width="60" align="center" />

      <el-table-column label="产品编码" min-width="140">

        <template slot-scope="scope"><el-input v-model="scope.row.materialCode" :disabled="formDisabled" placeholder="输入产品编码" @blur="fillLine(scope.row)" /></template>

      </el-table-column>

      <el-table-column prop="materialName" label="产品名称" min-width="140" />

      <el-table-column v-if="inventoryBarcodeEnabled" label="序列号" header-align="center" min-width="280">

        <template slot-scope="scope">

          <inventory-line-serial-panel v-if="isSerialMaterial(scope.row)" :value="scope.row.serialNos" :expected-qty="serialExpectedQty(scope.row)" :readonly="formDisabled" @input="v => $set(scope.row, 'serialNos', v)" />

          <span v-else style="color:#909399;">—</span>

        </template>

      </el-table-column>

      <el-table-column label="仓库库位" min-width="250">

        <template slot-scope="scope"><warehouse-location-select v-model="scope.row.wareHouseId" :disabled="formDisabled" /></template>

      </el-table-column>

      <el-table-column v-if="inventoryQtyShowSupplier" label="供应商" min-width="120">

        <template slot-scope="scope"><el-input v-model="scope.row.supplierName" :disabled="formDisabled" /></template>

      </el-table-column>

      <el-table-column label="账面数" width="150">

        <template slot-scope="scope"><el-input-number v-model="scope.row.bookQuantity" disabled :precision="2" style="width:100%" /></template>

      </el-table-column>

      <el-table-column label="实盘数" width="150">

        <template slot-scope="scope"><el-input v-model="scope.row.actualQuantity" type="number" min="0" step="0.01" :disabled="formDisabled" placeholder="请录入" style="width:100%" /></template>

      </el-table-column>

      <el-table-column label="差异" width="100" align="right">

        <template slot-scope="scope">{{ diffText(scope.row) }}</template>

      </el-table-column>

      <el-table-column v-if="!formDisabled" label="操作" width="70" align="center">

        <template slot-scope="scope"><el-button type="text" size="small" @click="form.lines.splice(scope.$index, 1)">删除</el-button></template>

      </el-table-column>

    </el-table>

    <span slot="footer">

      <el-button @click="visible = false">取消</el-button>

      <el-button v-if="!formDisabled" type="primary" :loading="saving" @click="save">确定</el-button>

    </span>



    <material-selector :visible.sync="materialVisible" multiple @select-multiple="chooseMaterials" />

    <el-dialog title="按仓库带出账面" :visible.sync="warehouseDialogVisible" width="420px" append-to-body>

      <el-form label-width="80px">

        <el-form-item label="仓库">

          <el-select v-model="warehouseDialogId" clearable filterable placeholder="请选择仓库" style="width:100%;">

            <el-option v-for="item in wareHouseList" :key="item.wareHouseId" :label="item.wareHouseName" :value="item.wareHouseId" />

          </el-select>

        </el-form-item>

      </el-form>

      <span slot="footer">

        <el-button @click="warehouseDialogVisible=false">取消</el-button>

        <el-button type="primary" :loading="stockLoading" @click="confirmLoadByWarehouse">确定</el-button>

      </span>

    </el-dialog>

  </el-dialog>

</template>



<script>

import WorkflowDocButtons from '../../components/WorkflowDocButtons.vue'

import request from '../../api/request'

import { fetchPerms } from '../../api/auth'

import WarehouseLocationSelect from '../../components/WarehouseLocationSelect.vue'

import MaterialSelector from '../../components/MaterialSelector.vue'

import InventoryLineSerialPanel from '../../components/InventoryLineSerialPanel.vue'

import { today, fillMaterialRow, downloadInventoryTemplate, importInventoryLines, showImportError, postDoc, mergeCountingLines } from './inventoryShared'

import inventoryQtyShowSupplierMixin from '../../mixins/inventory-qty-show-supplier'

import inventoryBarcodeMixin from '../../mixins/inventory-barcode'

import { workflowStatusText, workflowStatusTagType } from '../../utils/workflow'



export default {

  name: 'CountingAddOrUpdate',

  components: { WorkflowDocButtons, WarehouseLocationSelect, MaterialSelector, InventoryLineSerialPanel },

  mixins: [inventoryQtyShowSupplierMixin, inventoryBarcodeMixin],

  data() {

    return {

      kind: 'counting',

      visible: false,

      readonly: false,

      saving: false,

      actionBusy: false,

      codeReadonly: false,

      materialVisible: false,

      warehouseDialogVisible: false,

      warehouseDialogId: '',

      wareHouseList: [],

      stockLoading: false,

      permCodes: [],

      form: this.blank()

    }

  },

  computed: {

    formDisabled() {

      const wf = this.form.workflowStatus

      return this.readonly || String(this.form.approveStatus) === '2' || !!(wf && wf !== 'draft' && wf !== 'rejected')

    },

    canEditDoc() {

      const wf = this.form.workflowStatus

      return String(this.form.approveStatus) !== '2' && (!wf || wf === 'draft' || wf === 'rejected')

    },

    showViewToolbar() { return this.readonly && !!this.form.countingId },

    dialogTitle() {

      if (this.readonly || String(this.form.approveStatus) === '2') return '查看盘点单'

      return this.form.countingId ? '修改盘点单' : '新增盘点单'

    },

    statusText() { return workflowStatusText(this.form.workflowStatus, this.form.approveStatus) },

    statusTagType() { return workflowStatusTagType(this.form.workflowStatus, this.form.approveStatus) }

  },

  created() {

    this.loadPerms()

    this.loadInventoryQtyShowSupplierPolicy()

    this.loadInventoryBarcodePolicy()

  },

  methods: {

    isAuth(perm) {

      const user = this.$store.state.user || {}

      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []

      const role = String(user.roleCode || '')

      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true

      return this.permCodes.indexOf(perm) >= 0

    },

    loadPerms() {

      fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})

    },

    blank() { return { countingId: '', countingCode: '', countingDate: today(), remark: '', approveStatus: '0', workflowStatus: '', lines: [] } },

    init(id, readonly) {

      this.visible = true

      this.readonly = !!readonly

      this.codeReadonly = false

      this.actionBusy = false

      this.form = this.blank()

      if (!id) { this.resolveCode(); return }

      request.get('/inventory/counting/info/' + id).then(res => {

        const data = res.data || {}

        this.form = Object.assign(this.blank(), data, { lines: (data.lines || []).map(line => Object.assign({ bookQuantity: 0, actualQuantity: null }, line, { bookQuantity: Number(line.bookQuantity || 0), actualQuantity: line.actualQuantity == null ? null : Number(line.actualQuantity) })), approveStatus: data.approveStatus != null ? String(data.approveStatus) : '0' })

      }).catch(() => {})

    },

    onClosed() {

      this.form = this.blank()

      this.readonly = false

      this.warehouseDialogVisible = false

    },

    resolveCode() {

      request.post('/base/docNumberRule/resolve', { docType: 'counting' }).then(res => {

        const data = res.data || {}

        this.codeReadonly = !!data.codeReadonly

        if (this.codeReadonly && data.previewCode) this.form.countingCode = data.previewCode

      }).catch(() => {})

    },

    addLine() { this.form.lines.push({ materialCode: '', materialName: '', wareHouseId: '', supplierName: '', bookQuantity: 0, actualQuantity: null, batchNo: '', remark: '' }) },

    fillLine(row) { fillMaterialRow(row).then(m => { if (m === null) this.$message.warning('未找到该产品编码') }).catch(() => {}) },

    chooseMaterials(materials) {

      const ids = (materials || []).map(m => m.materialId).filter(Boolean)

      if (!ids.length) return

      this.loadStockLines({ materialIds: ids }).then(list => {

        if (list == null) return

        if (!list.length) { this.$message.warning('未找到所选物料的现存量，请手工维护明细或使用「按仓库带出」'); return }

        const stat = this.mergeStockLines(list)

        const covered = {}

        list.forEach(row => { covered[row.materialId] = true })

        const noStock = ids.filter(id => !covered[id]).length

        let msg = '已带出 ' + list.length + ' 条库存记录（新增 ' + stat.added + '，更新账面 ' + stat.updated + '）'

        if (noStock > 0) msg += '；' + noStock + '/' + ids.length + ' 个物料无现存量'

        this.$message.success(msg)

      })

    },

    openWarehouseStock() {

      this.warehouseDialogId = ''

      this.warehouseDialogVisible = true

      if (this.wareHouseList.length) return

      request.post('/base/wareHouse/list', { currentPage: 1, pageSize: 500 }).then(res => {

        const rows = (res.data && res.data.list) || []

        this.wareHouseList = rows.filter(item => String(item.isenabled || '0') === '0')

      }).catch(() => { this.wareHouseList = [] })

    },

    confirmLoadByWarehouse() {

      if (!this.warehouseDialogId) { this.$message.warning('请选择仓库'); return }

      this.loadStockLines({ materialIds: [], wareHouseId: this.warehouseDialogId }).then(list => {

        if (list == null) return

        if (!list.length) { this.$message.warning('该仓库下无现存量可盘点'); return }

        const stat = this.mergeStockLines(list)

        this.warehouseDialogVisible = false

        this.$message.success('已带出 ' + list.length + ' 条库存记录（新增 ' + stat.added + '，更新账面 ' + stat.updated + '）')

      })

    },

    loadStockLines(query) {

      this.stockLoading = true

      return request.post('/inventory/counting/stockLines', query).then(res => res.data || []).catch(() => null).finally(() => { this.stockLoading = false })

    },

    lineDedupeKey(line) {

      const mid = ((line.materialId || line.materialCode || '') + '').trim()

      const wh = ((line.wareHouseId || '') + '').trim()

      if (this.inventoryQtyShowSupplier) return mid + '@@' + wh + '@@' + ((line.supplierId || line.supplierName || '') + '').trim()

      return mid + '@@' + wh

    },

    mergeStockLines(stockLines) {

      if (!this.form.lines) this.form.lines = []

      let added = 0

      let updated = 0

      ;(stockLines || []).forEach(item => {

        const key = this.lineDedupeKey(item)

        const hit = this.form.lines.find(row => this.lineDedupeKey(row) === key)

        if (hit) {

          hit.bookQuantity = Number(item.bookQuantity || 0)

          hit.materialId = item.materialId

          hit.materialCode = item.materialCode

          hit.materialName = item.materialName

          updated++

        } else {

          this.form.lines.push({

            materialId: item.materialId, materialCode: item.materialCode, materialName: item.materialName,

            wareHouseId: item.wareHouseId || '', supplierId: '', supplierName: '',

            bookQuantity: Number(item.bookQuantity || 0), actualQuantity: null, batchNo: '', remark: ''

          })

          added++

        }

      })

      return { added, updated }

    },

    diffText(row) { return row.actualQuantity == null || row.actualQuantity === '' ? '待录入' : (Number(row.actualQuantity) - Number(row.bookQuantity || 0)).toFixed(2) },

    downloadTemplate() { downloadInventoryTemplate('counting', '盘点导入模板.xlsx').catch(() => this.$message.error('模板下载失败')) },

    doImport(req) {

      importInventoryLines('counting', req.file).then(lines => {

        lines.forEach(item => {

          this.form.lines.push({ materialId: item.materialId, materialCode: item.materialCode, materialName: item.materialName || '', wareHouseId: item.wareHouseId || '', supplierId: '', supplierName: '', bookQuantity: Number(item.bookQuantity || 0), actualQuantity: Number(item.actualQuantity || 0), batchNo: item.batchNo || '', remark: '' })

        })

        this.$message.success('导入成功')

      }).catch(e => showImportError(this, e))

    },

    save() {

      if (!this.codeReadonly && !(this.form.countingCode || '').trim()) { this.$message.error('单号不能为空'); return }

      if (!this.form.countingDate) { this.$message.error('日期不能为空'); return }

      if (this.form.lines.some(line => line.actualQuantity == null || line.actualQuantity === '' || !Number.isFinite(Number(line.actualQuantity)) || Number(line.actualQuantity) < 0)) {
        this.$message.error('请填写每条明细的有效实盘数，零库存请明确填 0')
        return
      }

      const merged = mergeCountingLines(this.form.lines, this.inventoryQtyShowSupplier)

      this.form.lines = merged.lines

      if (merged.hadDuplicate) this.$message.warning('检测到重复明细，已自动合并后再保存')

      if (!this.form.lines.length) { this.$message.error('请至少维护一条盘点明细'); return }

      const id = this.form.countingId

      const body = { id, code: this.form.countingCode, bizDate: this.form.countingDate, countingId: id, countingCode: this.form.countingCode, countingDate: this.form.countingDate, remark: this.form.remark, lines: this.form.lines }

      this.saving = true

      postDoc('counting', body, id).then(() => {

        this.$message.success('操作成功')

        this.visible = false

        this.$emit('refreshDataList')

      }).catch(() => {}).finally(() => { this.saving = false })

    },

    approve(pass) {

      this.$confirm(pass ? '审核后将按差异调整库存，是否继续?' : '弃审将冲回盘点差异，是否继续?', '提示', { type: 'warning' }).then(() => {

        this.actionBusy = true

        request.post('/inventory/counting/' + (pass ? 'approve' : 'unapprove'), { id: this.form.countingId }).then(() => {

          this.$message.success('操作成功')

          this.visible = false

          this.$emit('refreshDataList')

        }).catch(() => {}).finally(() => { this.actionBusy = false })

      }).catch(() => {})

    },

    remove() {

      this.$confirm('确定删除该单据?', '提示', { type: 'warning' }).then(() => {

        this.actionBusy = true

        request.post('/inventory/counting/delete', { id: this.form.countingId }).then(() => {

          this.$message.success('操作成功')

          this.visible = false

          this.$emit('refreshDataList')

        }).catch(() => {}).finally(() => { this.actionBusy = false })

      }).catch(() => {})

    }

  }

}

</script>



<style scoped>

.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }

.doc-dialog-title { font-size: 16px; font-weight: 600; }

.doc-dialog-actions .el-button { margin-left: 0; }

.line-tools { margin-bottom: 10px; }

</style>


